/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';
import type { LieuFormationHistoryGridDto } from './LieuFormationHistoryGridDto';
import {
    LieuFormationHistoryGridDtoFromJSON,
    LieuFormationHistoryGridDtoFromJSONTyped,
    LieuFormationHistoryGridDtoToJSON,
} from './LieuFormationHistoryGridDto';

/**
 * 
 * @export
 * @interface LieuFormationHistoryGridDtoPaginatedResults
 */
export interface LieuFormationHistoryGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof LieuFormationHistoryGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<LieuFormationHistoryGridDto>}
     * @memberof LieuFormationHistoryGridDtoPaginatedResults
     */
    results?: Array<LieuFormationHistoryGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof LieuFormationHistoryGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the LieuFormationHistoryGridDtoPaginatedResults interface.
 */
export function instanceOfLieuFormationHistoryGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function LieuFormationHistoryGridDtoPaginatedResultsFromJSON(json: any): LieuFormationHistoryGridDtoPaginatedResults {
    return LieuFormationHistoryGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function LieuFormationHistoryGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): LieuFormationHistoryGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(LieuFormationHistoryGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function LieuFormationHistoryGridDtoPaginatedResultsToJSON(value?: LieuFormationHistoryGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(LieuFormationHistoryGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

